import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useSingleSaleStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            width: '100%',
            height: '100%',
            background: '#ffffff',
            padding: '24px 16px',

            [theme.breakpoints.down('sm')]: {
                overflowY: 'scroll'
            },
            [theme.breakpoints.up('md')]: {
                padding: '30px 25px'
            }
        }
    })
);
